import { render } from "./CloneVpcOffering.vue?vue&type=template&id=43077adb&scoped=true"
import script from "./CloneVpcOffering.vue?vue&type=script&lang=js"
export * from "./CloneVpcOffering.vue?vue&type=script&lang=js"

import "./CloneVpcOffering.vue?vue&type=style&index=0&id=43077adb&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43077adb"]])

export default __exports__